import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { push } from 'react-router-redux'
import { Field, reduxForm, SubmissionError } from 'redux-form'
import LoadingProgress from '../components/LoadingProgress'

import { fetchRule, updateRule } from '../actions/rules'
import { renderInputField, renderSelectField, renderTextAreaField } from '../utils/forms'
import '../styles/FormModals.css'

class RuleEditForm extends React.Component {
       constructor(props) {
              super(props)

              this.state = {
                     loaded: false
              }

              this.load = this.load.bind(this)
              this.submit = this.submit.bind(this)
       }

       componentDidMount() {
              const { fetchRule, match } = this.props

              // In route mode the rule is fetched from the URL param;
              // in modal mode it is already in the store (loaded by the rules view).
              if (match && match.params && match.params.id) {
                     fetchRule(match.params.id)
              }

              this.load(this.props)
       }

       componentWillReceiveProps(nextProps) {
              this.load(nextProps)
       }

       load(props) {
              const { rule, initialize } = props;

              if (!this.state.loaded && rule) {
                     this.setState({
                            loaded: true
                     });
                     initialize(rule);  // Initialize form with rule data
              }
       }

       submit(props) {
              const { updateRule, rule } = this.props

              return this.props.updateRule(rule._id, props)
                     .then(response => {
                            if (response.error) {
                                   throw new SubmissionError({
                                          _error: response.error.message,
                                          ...response.error.fields
                                   })
                            }

                            // If in modal mode, close modal and refresh the list
                            if (this.props.isModal) {
                                   this.props.closeModal();
                                   if (this.props.refreshRules) {
                                          this.props.refreshRules();
                                   }
                            }

                            return response
                     })
       }

       render() {
              const { rule, error, pristine, submitting, handleSubmit, isModal } = this.props
              const { loaded } = this.state

              if (!loaded || !rule) {
                     return (
                            <LoadingProgress />
                     )
              }

              return (
                     <form className="opform" onSubmit={handleSubmit(this.submit)}>
                            {!isModal && (
                                   <h1>
                                          <span className="text-vw-dark">EDITAR </span>
                                          <span className="text-vw-light">REGLA DE NEGOCIO</span>
                                   </h1>
                            )}

                            <div className="opform-section">
                                   <div className="opform-section-title">
                                          <i className="fas fa-pencil-ruler"></i>
                                          Regla
                                   </div>
                                   <div className="opform-grid">
                                          <Field name="Name"
                                                 type="text"
                                                 component={renderInputField}
                                                 label="Nombre de la regla" />
                                          <Field name="Type"
                                                 component={renderSelectField}
                                                 label="Tipo">
                                                 <option value="">Selecciona un tipo...</option>
                                                 <option value="MaxDayDiscount">Descuento por días</option>
                                                 <option value="AlwaysDiscount">Descuento fijo</option>
                                          </Field>
                                   </div>
                            </div>

                            <div className="opform-section">
                                   <div className="opform-section-title">
                                          <i className="fas fa-sliders-h"></i>
                                          Configuración
                                   </div>
                                   <div className="opform-grid">
                                          <Field name="MaxDays"
                                                 type="number"
                                                 component={renderInputField}
                                                 label="Dias aplicables" />
                                          <Field name="DiscountPercentage"
                                                 type="number"
                                                 component={renderInputField}
                                                 label="Porcentaje de descuento" />
                                   </div>
                                   <Field name="Locker"
                                          component={renderSelectField}
                                          label="Taquilla">
                                          <option value="ALL">Todas</option>
                                          <option value="2PAX">2 Equipos de esquí</option>
                                          <option value="3PAX">3 Equipos de esquí</option>
                                          <option value="4PAX">4 Equipos de esquí</option>
                                          <option value="3PAXSS">3 Equipos sin secado</option>
                                          <option value="BNS">Standard</option>
                                          <option value="BNM">Medium</option>
                                   </Field>
                            </div>

                            <div className="opform-section">
                                   <div className="opform-section-title">
                                          <i className="fas fa-align-left"></i>
                                          Otros
                                   </div>
                                   <Field name="Condition"
                                          component={renderTextAreaField}
                                          label="Condiciones" />
                            </div>

                            {error && <div className="alert alert-danger">{error}</div>}

                            {!isModal && (
                                   <button className="btn btn-vw opform-submit" type="submit"
                                          disabled={pristine || submitting}>
                                          <i className="fas fa-save mr-2"></i>
                                          Guardar
                                   </button>
                            )}
                            {isModal && (
                                   <div className="opform-footer">
                                          <button
                                                 className="btn btn-secondary"
                                                 type="button"
                                                 onClick={this.props.closeModal}>
                                                 <i className="fas fa-times mr-2"></i>
                                                 Cancelar
                                          </button>
                                          <button
                                                 className="btn btn-vw"
                                                 type="submit"
                                                 disabled={pristine || submitting}>
                                                 <i className="fas fa-save mr-2"></i>
                                                 Guardar
                                          </button>
                                   </div>
                            )}
                     </form>
              )
       }
}

RuleEditForm = reduxForm({
       form: 'RuleEditForm',
       keepDirtyOnReinitialize: true,
       enableReinitialize: true,
       updateUnregisteredFields: true,
       onSubmitSuccess: (result, dispatch, props) => {
              // Only push to route if NOT in modal mode
              if (!props.isModal) {
                     props.push(`/rules`)
              }
       }
})(RuleEditForm)

const mapStateToProps = state => {
       return {
              rule: state.rules.rule,
              initialValues: state.rules.rule,
       }
}

const mapDispatchToProps = dispatch => ({
       updateRule: bindActionCreators(updateRule, dispatch),
       fetchRule: bindActionCreators(fetchRule, dispatch),
       push: bindActionCreators(push, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(RuleEditForm)
